module.exports = __webpack_public_path__ + "img/puberty-decal-28.7990f6ad.png";